import { ColumnDef } from '@tanstack/react-table';
import { FaUpRightFromSquare } from 'react-icons/fa6';

import {
	AbsenceChangesModal,
	AdressChangesModal,
	ExtraTripChangeTableRow,
	MappedChangesModal,
	PositionChangesModal,
	ShiftChangesModal,
	SituationChangesModal,
	StatusChangesModal,
	VacationChangesModal,
	WorkStationChangesModal,
} from '@/types/EmployeeChangesModal';
import TableCellText from '../../components/atoms/TableCellText';

export const MappedChangesColumns: Array<ColumnDef<MappedChangesModal>> = [
	{
		accessorKey: 'trainingName',
		accessorFn: (row) => row.trainingName,
		header: 'Treinamento',
		cell: (props) => {
			return (
				<div className="w-full">
					<div className="w-full">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'checked',
		accessorFn: (row) => row.checked,
		header: 'Mapeado',
		cell: (props) => {
			return (
				<div className="w-40">
					<TableCellText
						text={(props.getValue() as boolean) ? 'SIM' : 'NÃO'}
						width="full"
					/>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const AdressChangesColumns: Array<ColumnDef<AdressChangesModal>> = [
	{
		accessorKey: 'address',
		accessorFn: (row) => row.address,
		header: 'Endereço',
		cell: (props) => {
			return (
				<div className="w-full">
					<div className="w-full">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const StatusChangesColumns: Array<ColumnDef<StatusChangesModal>> = [
	{
		accessorKey: 'status',
		accessorFn: (row) => row.status,
		header: 'Status',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const WorkStationChangesModalColumns: Array<
	ColumnDef<WorkStationChangesModal>
> = [
	{
		accessorKey: 'workStationName',
		accessorFn: (row) => row.workStationName,
		header: 'Status',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const PositionChangesModalColumns: Array<
	ColumnDef<PositionChangesModal>
> = [
	{
		accessorKey: 'generalInformationJobTitleName',
		header: 'Cargo',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'boardName',
		header: 'Diretoria',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'managementName',
		header: 'Gerência',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'coordinationName',
		header: 'Coordenação',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'workStationName',
		header: 'Local de Trabalho',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
];

const trainingDay = <T,>(): ColumnDef<T> => ({
	accessorKey: 'trainingDay',
	header: 'Dia de Treinamento',
	cell: (props) => {
		return (
			<div className="w-40">
				<div className="w-40">
					<TableCellText text={props.getValue() as string} width="full" />
				</div>
			</div>
		);
	},
	enableSorting: false,
});

const situation = <T,>(): ColumnDef<T> => ({
	accessorKey: 'situation',
	header: 'Situação',
	cell: (props) => {
		return (
			<div className="w-40">
				<div className="w-40">
					<TableCellText text={props.getValue() as string} width="full" />
				</div>
			</div>
		);
	},
	enableSorting: false,
});

export const SituationChangesColumns: Array<ColumnDef<SituationChangesModal>> =
	[trainingDay<SituationChangesModal>(), situation<SituationChangesModal>()];

export const ShiftChangesColumns: Array<ColumnDef<ShiftChangesModal>> = [
	trainingDay<ShiftChangesModal>(),
	situation<ShiftChangesModal>(),
	{
		accessorKey: 'shift',
		header: 'Turno',
		cell: (props) => {
			return (
				<div className="w-40">
					<div className="w-40">
						<TableCellText text={props.getValue() as string} width="full" />
					</div>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const VacationChangesColumns: Array<ColumnDef<VacationChangesModal>> = [
	{
		accessorKey: 'vacationPeriods',
		header: 'Período de Férias',
		cell: (props) => {
			const periods = props.getValue() as Array<{
				startDate: string;
				endDate: string;
			}>;

			return (
				<div className="w-40">
					{periods.map((period, index) => (
						<div key={index} className="w-40">
							<TableCellText
								text={`${new Date(period.startDate).toLocaleDateString()} - ${new Date(period.endDate).toLocaleDateString()}`}
								width="full"
							/>
						</div>
					))}
				</div>
			);
		},
		enableSorting: false,
	},
];

export const AbsenceChangesColumns: Array<ColumnDef<AbsenceChangesModal>> = [
	{
		accessorKey: 'absencePeriods',
		header: 'Período de Licença',
		cell: (props) => {
			const row = props.row.original;
			const periods =
				(props.getValue() as
					| Array<{
							startDate: string | null;
							endDate: string | null;
					  }>
					| undefined) ??
				(row.startDate && row.endDate
					? [{ startDate: row.startDate, endDate: row.endDate }]
					: []);

			return (
				<div className="w-48">
					{periods.map((period, index) => (
						<div key={index} className="w-48">
							<TableCellText
								text={`${new Date(period.startDate as string).toLocaleDateString()} - ${new Date(period.endDate as string).toLocaleDateString()}`}
								width="full"
							/>
						</div>
					))}
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'type',
		header: 'Tipo',
		cell: (props) => {
			return (
				<div className="w-40">
					<TableCellText
						text={(props.getValue() as string) ?? ''}
						width="full"
					/>
				</div>
			);
		},
		enableSorting: false,
	},
	{
		accessorKey: 'specification',
		header: 'Especificação',
		cell: (props) => {
			return (
				<div className="w-48">
					<TableCellText
						text={(props.getValue() as string) ?? ''}
						width="full"
					/>
				</div>
			);
		},
		enableSorting: false,
	},
];

export const ExtraTripChangesColumns = (
	employeeId?: number,
): Array<ColumnDef<ExtraTripChangeTableRow>> => {
	const columns: Array<ColumnDef<ExtraTripChangeTableRow>> = [
		trainingDay<ExtraTripChangeTableRow>(),
		situation<ExtraTripChangeTableRow>(),
	];

	columns.push({
		id: 'viewExtraTrip',
		header: () => (
			<div
				className={`whitespace-nowrap px-2 text-center ${employeeId == null ? 'invisible' : ''}`}
			>
				Visualizar
			</div>
		),
		enableSorting: false,
		meta: {
			headerClassName: 'w-[1%] whitespace-nowrap text-center',
			stickyClassName: 'w-[1%] whitespace-nowrap text-center',
		},
		cell: (props) => {
			if (employeeId == null) {
				return <div className="w-8" />;
			}

			const extraTripSolicitationId =
				props.row.original.extraTripSolicitationId;

			return (
				<div className="flex items-center justify-center">
					<a
						className="flex items-center justify-center"
						title="Visualizar"
						href={`/home/colaborador/${employeeId}/idas-extras/${extraTripSolicitationId}`}
						target="_blank"
					>
						<FaUpRightFromSquare className="text-primary" size={16} />
					</a>
				</div>
			);
		},
	});

	return columns;
};
